import {
  SYSTEM_CERTTYPE_MODAL_CHANGE,
} from './constants';

export function certTypeModalChange(visible,type) {
  return {
    type: SYSTEM_CERTTYPE_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_CERTTYPE_MODAL_CHANGE:
      return {
        ...state,
        certTypeModalType:action.data.type,
        certTypeModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/certTypeModalChange.js